import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, createTextVNode as _createTextVNode, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, normalizeClass as _normalizeClass, createCommentVNode as _createCommentVNode, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

_pushScopeId("data-v-1be984c2")
const _hoisted_1 = { class: "card mb-3" }
const _hoisted_2 = { class: "card-body" }
const _hoisted_3 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-3" }, "Details:", -1)
const _hoisted_4 = { class: "row" }
const _hoisted_5 = { class: "col-md-4 col-sm-6 col-12 mb-5" }
const _hoisted_6 = /*#__PURE__*/_createElementVNode("b", null, "Loss Date:", -1)
const _hoisted_7 = { class: "col-md-8 col-sm-6 col-12 mb-3" }
const _hoisted_8 = /*#__PURE__*/_createElementVNode("b", null, "Loss Type:", -1)
const _hoisted_9 = /*#__PURE__*/_createElementVNode("h5", null, "Description", -1)
const _hoisted_10 = /*#__PURE__*/_createElementVNode("h5", null, "Know prior damage:", -1)
const _hoisted_11 = { class: "mt-5 mb-4" }
const _hoisted_12 = {
  class: "nav nav-tabs",
  id: "nav-tab",
  role: "tablist"
}
const _hoisted_13 = ["onClick"]
const _hoisted_14 = { class: "card-body" }
const _hoisted_15 = {
  class: "tab-content",
  id: "nav-tabContent"
}
const _hoisted_16 = {
  key: 0,
  class: "card mb-3"
}
const _hoisted_17 = { class: "card-body" }
const _hoisted_18 = /*#__PURE__*/_createElementVNode("h4", null, "Device Details:", -1)
const _hoisted_19 = { class: "mb-5" }
const _hoisted_20 = /*#__PURE__*/_createElementVNode("h5", null, "Before Photos:", -1)
const _hoisted_21 = { class: "row" }
const _hoisted_22 = ["href"]
const _hoisted_23 = ["src"]
const _hoisted_24 = { class: "card mb-3" }
const _hoisted_25 = { class: "card-body" }
const _hoisted_26 = /*#__PURE__*/_createElementVNode("h4", null, "Claim Photos:", -1)
const _hoisted_27 = { key: 0 }
const _hoisted_28 = { class: "row" }
const _hoisted_29 = ["href"]
const _hoisted_30 = ["src"]
const _hoisted_31 = { class: "card" }
const _hoisted_32 = { class: "card-body" }
const _hoisted_33 = /*#__PURE__*/_createElementVNode("h4", { class: "mb-3" }, "Other Claim Files:", -1)
const _hoisted_34 = { class: "mb-3" }
const _hoisted_35 = /*#__PURE__*/_createElementVNode("h5", null, "Videos", -1)
const _hoisted_36 = { key: 0 }
const _hoisted_37 = { class: "row" }
const _hoisted_38 = { class: "img-thumbnail" }
const _hoisted_39 = {
  class: "img-fluid",
  controls: "",
  preload: "none"
}
const _hoisted_40 = ["src"]
const _hoisted_41 = /*#__PURE__*/_createTextVNode(" Your browser does not support the video tag. ")
const _hoisted_42 = { class: "fs-7" }
const _hoisted_43 = ["href"]
const _hoisted_44 = /*#__PURE__*/_createElementVNode("h5", null, "Files", -1)
const _hoisted_45 = { key: 0 }
const _hoisted_46 = ["href"]
_popScopeId()

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", null, [
    (_ctx.claim)
      ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
          _createElementVNode("section", _hoisted_1, [
            _createElementVNode("div", _hoisted_2, [
              _hoisted_3,
              _createElementVNode("div", _hoisted_4, [
                _createElementVNode("div", _hoisted_5, [
                  _createElementVNode("div", null, [
                    _hoisted_6,
                    _createTextVNode(" " + _toDisplayString(_ctx.formatLocal(_ctx.claim.lossYear, _ctx.claim.lossMonth, _ctx.claim.lossDay)), 1)
                  ])
                ]),
                _createElementVNode("div", _hoisted_7, [
                  _hoisted_8,
                  _createTextVNode(" " + _toDisplayString(_ctx.claim.lossType), 1)
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_9,
                _createElementVNode("p", null, _toDisplayString(_ctx.claim.description), 1),
                _hoisted_10,
                _createElementVNode("p", null, _toDisplayString(_ctx.claim.knownDamage), 1)
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_11, [
            _createElementVNode("nav", null, [
              _createElementVNode("div", _hoisted_12, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claim.devices, (device) => {
                  return (_openBlock(), _createElementBlock("button", {
                    key: device.id,
                    class: _normalizeClass([{ active: _ctx.isActiveTab(`Tab${device.id}`) }, "nav-link"]),
                    id: "nav-home-tab",
                    "data-bs-toggle": "tab",
                    "data-bs-target": "#nav-home",
                    type: "button",
                    role: "tab",
                    "aria-controls": "nav-home",
                    "aria-selected": "true",
                    onClick: ($event: any) => (_ctx.activeTab(`Tab${device.id}`))
                  }, _toDisplayString(device.brand) + " " + _toDisplayString(device.model) + " " + _toDisplayString(device.serialNumber), 11, _hoisted_13))
                }), 128))
              ])
            ]),
            _createElementVNode("div", _hoisted_14, [
              _createElementVNode("section", null, [
                _createElementVNode("div", _hoisted_15, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claim.devices, (device) => {
                    return (_openBlock(), _createElementBlock("div", {
                      key: device.id,
                      class: "tab-pane fade show active",
                      id: "nav-home",
                      role: "tabpanel",
                      "aria-labelledby": "nav-home-tab"
                    }, [
                      (_ctx.isActiveTab(`Tab${device.id}`))
                        ? (_openBlock(), _createElementBlock("section", _hoisted_16, [
                            _createElementVNode("div", _hoisted_17, [
                              _hoisted_18,
                              _createElementVNode("p", _hoisted_19, _toDisplayString(device.brand) + " " + _toDisplayString(device.model) + " " + _toDisplayString(device.serialNumber), 1),
                              _createElementVNode("div", null, [
                                _hoisted_20,
                                _createElementVNode("div", _hoisted_21, [
                                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(device.images, (image) => {
                                    return (_openBlock(), _createElementBlock("div", {
                                      class: "col-lg-3 col-md-4 col-sm-6 col-6 mb-5",
                                      key: image.id
                                    }, [
                                      _createElementVNode("a", {
                                        href: image.publicUrl,
                                        target: "_blank"
                                      }, [
                                        _createElementVNode("img", {
                                          class: "img-thumbnail",
                                          src: image.publicUrl
                                        }, null, 8, _hoisted_23),
                                        _createElementVNode("span", null, _toDisplayString(image.fileName), 1)
                                      ], 8, _hoisted_22)
                                    ]))
                                  }), 128))
                                ])
                              ])
                            ])
                          ]))
                        : _createCommentVNode("", true)
                    ]))
                  }), 128))
                ])
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_24, [
            _createElementVNode("div", _hoisted_25, [
              _hoisted_26,
              (_ctx.claim.images === null || _ctx.claim.images.length === 0)
                ? (_openBlock(), _createElementBlock("div", _hoisted_27, " No images were submitted "))
                : _createCommentVNode("", true),
              _createElementVNode("div", _hoisted_28, [
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claim.images, (image) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "col-lg-3 col-md-4 col-sm-6 col-6 mb-5",
                    key: image.id
                  }, [
                    _createElementVNode("a", {
                      href: image.publicUrl,
                      target: "_blank"
                    }, [
                      _createElementVNode("img", {
                        class: "img-thumbnail",
                        src: image.publicUrl
                      }, null, 8, _hoisted_30),
                      _createElementVNode("span", null, _toDisplayString(image.fileName), 1)
                    ], 8, _hoisted_29)
                  ]))
                }), 128))
              ])
            ])
          ]),
          _createElementVNode("section", _hoisted_31, [
            _createElementVNode("div", _hoisted_32, [
              _hoisted_33,
              _createElementVNode("div", _hoisted_34, [
                _hoisted_35,
                (_ctx.claim.images === null || _ctx.claim.videos.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_36, " No videos were submitted "))
                  : _createCommentVNode("", true),
                _createElementVNode("div", _hoisted_37, [
                  (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claim.videos, (video) => {
                    return (_openBlock(), _createElementBlock("div", {
                      class: "col-lg-4 col-md-6 col-sm-12 col-12 mb-3",
                      key: video.id
                    }, [
                      _createElementVNode("div", _hoisted_38, [
                        _createElementVNode("video", _hoisted_39, [
                          _createElementVNode("source", {
                            src: video.publicUrl,
                            type: "video/mp4"
                          }, null, 8, _hoisted_40),
                          _hoisted_41
                        ]),
                        _createElementVNode("div", _hoisted_42, _toDisplayString(video.fileName), 1)
                      ]),
                      _createElementVNode("a", {
                        class: "text-muted fs-7",
                        href: video.publicUrl,
                        target: "_blank"
                      }, "Download", 8, _hoisted_43)
                    ]))
                  }), 128))
                ])
              ]),
              _createElementVNode("div", null, [
                _hoisted_44,
                (_ctx.claim.images === null || _ctx.claim.files.length === 0)
                  ? (_openBlock(), _createElementBlock("div", _hoisted_45, " No files were submitted "))
                  : _createCommentVNode("", true),
                (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(_ctx.claim.files, (file) => {
                  return (_openBlock(), _createElementBlock("div", {
                    class: "mb-2",
                    key: file.id
                  }, [
                    _createElementVNode("a", {
                      href: file.publicUrl,
                      target: "_blank"
                    }, [
                      _createElementVNode("span", null, _toDisplayString(file.fileName), 1)
                    ], 8, _hoisted_46)
                  ]))
                }), 128))
              ])
            ])
          ])
        ], 64))
      : _createCommentVNode("", true)
  ]))
}